import { useTranslation } from "react-i18next";
import { z } from "zod";

export const useAddBudgetTransactionCategorySchema = () => {
  const { t } = useTranslation();

  return z.object({
    name: z.string().min(1, t("common.form.field.errors.required")),
  });
};

export type TAddBudgetTransactionCategorySchema = z.infer<
  ReturnType<typeof useAddBudgetTransactionCategorySchema>
>;
